import React from 'react';
import Image from 'frontastic/lib/image';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import Breadcrumb from 'components/commercetools-ui/atoms/breadcrumb';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import { HomeIcon } from '@heroicons/react/24/outline';
import usePath from 'helpers/hooks/usePath';
import usePreloadImages from 'helpers/hooks/usePreloadImages';
import useWindowWidth from 'helpers/hooks/useBrowerWidth';

export type PLPCMSComponentProps = {
  data?: any;
};

const PLPCMSComponent = ({ data }: React.PropsWithChildren<PLPCMSComponentProps>) => {
  const { path } = usePath();
  const width = useWindowWidth();
  const isBimLibraryPage = path.includes("/bim-library");
  
  //Will ask Uzman and remove this function if not needed since he created this method
  const getTitleFromSlug = () => {
    if (path.split('/').slice(-2, -1)[0] === 'grab-rails') return 'Grab Rails';
    if (path.split('/').slice(-2, -1)[0] === 'toilets') return 'Toilets';
    if (path.split('/').slice(-2, -1)[0] === 'bathroom') return 'Bathroom';
    if (path.split('/').slice(-2, -1)[0] === 'basins') return 'Basins';
    if (path.split('/').slice(-2, -1)[0] === 'accessories') return 'Accessories';
    if (path.split('/').slice(-2, -1)[0] === 'spare-parts-valves') return 'Spare Parts & Valve';
    if (path.split('/').slice(-2, -1)[0] === 'showers') return 'Showers';
    if (path.split('/').slice(-2, -1)[0] === 'baths') return 'Baths';
    if (path.split('/').slice(-2, -1)[0] === 'caroma') return 'Caroma';
    if (path.split('/').slice(-2, -1)[0] === 'caroma-smart-command') return 'Smart Command';
    if (path.split('/').slice(-2, -1)[0] === 'caroma-livewell') return 'Caroma Livewell';
    if (path.split('/').slice(-2, -1)[0] === 'clark') return 'Clark';
    if (path.split('/').slice(-2, -1)[0] === 'laundry-tubs') return 'Laundry Tubs';
    if (path.split('/').slice(-2, -1)[0] === 'tapware') return 'Tapware & Mixers';
    if (path.split('/').slice(-2, -1)[0] === 'kitchen-laundry') return 'Kitchen & Laundry';
    if (path.split('/').slice(-2, -1)[0] === 'independent-living') return 'Independent Living & Care';
    if (path.split('/').slice(-2, -1)[0] === 'toilet-suites') return 'Toilets';
    if (path.split('/').slice(-2, -1)[0] === 'sanitaryware') return 'Sanitaryware';
    if (path.split('/').slice(-2, -1)[0] === 'as14281-ambulant') return 'AS1428.1 Ambulant';
    if (path.split('/').slice(-2, -1)[0] === 'as14281-accessible') return 'AS14281 Accessible';
    if (path.split('/').slice(-2, -1)[0] === 'touchless-bathrooms') return 'Touchless Bathrooms';
    if (path.split('/').slice(-2, -1)[0] === 'pre-fabrication-frames') return 'Pre-fabrication Frames';
    if (path.split('/').slice(-2, -1)[0] === 'toilet-suites') return 'Toilet Suites';
    if (path.split('/').slice(-2, -1)[0] === 'toilet-seats') return 'Toilet Seats';
    if (path.split('/').slice(-2, -1)[0] === 'pans') return 'Pans';
    if (path.split('/').slice(-2, -1)[0] === 'cisterns') return 'Cisterns';
    if (path.split('/').slice(-2, -1)[0] === 'bidets') return 'Bidgets';
    if (path.split('/').slice(-2, -1)[0] === 'urinals') return 'Urinals';
    if (path.split('/').slice(-2, -1)[0] === 'buttons-flush-plates') return 'Buttons Flush Plates';
    if (path.split('/').slice(-2, -1)[0] === 'care-toilets') return 'Care Toilets';
    if (path.split('/').slice(-2, -1)[0] === 'above-counter') return "Above Counter";
    if (path.split('/').slice(-2, -1)[0] === 'under-counter') return "Under Counter";
    if (path.split('/').slice(-2, -1)[0] === 'inset') return "Inset";
    if (path.split('/').slice(-2, -1)[0] === 'semi-recessed') return "Semi Recessed";
    if (path.split('/').slice(-2, -1)[0] === 'wall-mountedwall-hung') return "Wall Mounted Hung";
    if (path.split('/').slice(-2, -1)[0] === 'shower-systems') return "Shower Systems";
    if (path.split('/').slice(-2, -1)[0] === 'overhead-showers') return "Overhead Showers";
    if (path.split('/').slice(-2, -1)[0] === 'rail-showers') return "Rail Showers";
    if (path.split('/').slice(-2, -1)[0] === 'hand-showers') return "Hand Showers";
    if (path.split('/').slice(-2, -1)[0] === 'freestanding') return "Freestanding";
    if (path.split('/').slice(-2, -1)[0] === 'island') return "Island";
    if (path.split('/').slice(-2, -1)[0] === 'back-to-wall') return `Back to Wall`;
    if (path.split('/').slice(-2, -1)[0] === 'kitchen-sinks') return "Kitchen Sinks";
    if (path.split('/').slice(-2, -1)[0] === 'tapware-mixers') return "Tapware Mixers";
    if (path.split('/').slice(-2, -1)[0] === 'Laundry-tubs') return "Laundry Tubs";
    if (path.split('/').slice(-2, -1)[0] === 'bathroom-accessories') return "Bathroom Accessories";
    if (path.split('/').slice(-2, -1)[0] === 'kitchen-laundry-accessories') return "Kitchen Laundry Accessories";
    if (path.split('/').slice(-2, -1)[0] === 'care-accessories') return "Care Accessories";
    if (path.split('/').slice(-2, -1)[0] === 'sanitaryware-spares') return "Sanitaryware Spares";
    if (path.split('/').slice(-2, -1)[0] === 'tapware-spares') return "Tapware Spares";
    if (path.split('/').slice(-2, -1)[0] === 'basin-spares') return "Basin Spares";
    if (path.split('/').slice(-2, -1)[0] === 'shower-spares') return "shower-spares";
    if (path.split('/').slice(-2, -1)[0] === 'bath-spares') return "bath-spares";
    if (path.split('/').slice(-2, -1)[0] === 'kitchen-laundry-spares') return "Kitchen Laundry Spares";
    if (path.split('/').slice(-2, -1)[0] === 'tmv-valves') return "TMV valves";
    if (path.split('/').slice(-2, -1)[0] === 'valve-spares') return "Valve spares";
    if (path.split('/').slice(-2, -1)[0] === 'touchless') return "Touchless";
    if (path.split('/').slice(-2, -1)[0] === 'lead-free') return "Lead Free";
    if (path.split('/').slice(-2, -1)[0] === 'basin-mixers') return "Basin Mixers";
    if (path.split('/').slice(-2, -1)[0] === 'hob-mixers') return "Hob Mixers";

    return `${path.split('/').slice(-2, -1)[0]?.replaceAll('-', ' ').replace(' ', ' & ')}`;
  };


  const generateBreadcrumbs = () => {
    const pathSegments = path.split('/').filter(Boolean);

    
    // Remove the last element from the pathSegments array
    const pathSegmentsWithoutLast = pathSegments.slice(0, -1);

    return pathSegmentsWithoutLast.map((segment, index) => {
      const href = `/${pathSegmentsWithoutLast.slice(0, index + 1).join('/')}/`;
      const isProductOrBrandSegment = segment.includes('products') ||
      segment.includes('brands') ||
      segment.includes('solutions') ||
      segment.includes('sectors') ||
      segment.includes('tools-resources');

      // Function to capitalize the first two letters if the segment is "nz4121 accessible"
      const formatSegment = (segment: string) => {
        if (segment.toLowerCase() === 'nz4121 accessible' || segment.toLowerCase() === 'as14281 accessible') {
          return segment.charAt(0).toUpperCase() + segment.charAt(1).toUpperCase() + segment.slice(2);
        }
        return segment;
      };

      return (
        <span key={segment}>
          {isProductOrBrandSegment ? (
            <span className="text-12 font-normal capitalize leading-4 text-primary-black" style={{ cursor: 'default' }}>
              {formatSegment(segment.replace(/-/g, ' ')) === 'tools resources'
                ? 'Tools & Resources'
                : formatSegment(segment.replace(/-/g, ' '))}
            </span>

          ) : (
            <Link link={href}>
              <span className={`text-12 font-normal capitalize leading-4 text-[#666]`}>
                {formatSegment(segment.replace(/-/g, ' '))}
              </span>
            </Link>
          )}
        </span>
      );
    });
  };

  const cmsComponentData = data?.sections?.[0]?.section_with_image_text || data?.section_with_image_text || '';
  const cmsCssClass = data?.sections?.[0]?.section_with_image_text.additional_css;
  usePreloadImages([cmsComponentData?.image?.url]);
  let bimLibraryImageClasses = "";
  if (width && isBimLibraryPage) {
    if (width < 540) {
      bimLibraryImageClasses = "h-[19rem]";
    } else if (width < 740) {
      bimLibraryImageClasses = "h-[25rem]";
    } else if (width > 2100){
      bimLibraryImageClasses = "h-[40rem]";
    }else{
      bimLibraryImageClasses = "h-[23rem] md:h-[33rem] lg:h-[25rem] xl:h-[31rem]";
    }
  }
   return (
    <>
      <div className="hidden px-24 pb-8 pt-16 md:!block md:px-28 lg:px-48 xl:px-60 2xl:pl-60 2xl:pr-80 3xl:pl-80">
        <Breadcrumb Separator={<ChevronRightIcon className="w-16" />} listClassName="!gap-x-16">
          <Link link={'/'}>
            <HomeIcon className="mt-6 w-20" />
          </Link>
          {generateBreadcrumbs()}
        </Breadcrumb>
      </div>
      <div className={`relative left-full w-screen -translate-x-full lg:grid lg:grid-cols-12 ${cmsCssClass}`}>
        <div id="advice-section" className={`flex flex-col items-center lg:col-span-12 lg:flex-row-reverse lg:px-0`}>
          <div className={`relative ${isBimLibraryPage ? bimLibraryImageClasses:"h-[23rem] md:h-[50rem] lg:h-[30rem] xl:h-[35rem] 2xl:h-[40rem]"} w-full lg:mb-50 lg:flex-1 lg:flex-grow 2xl:mb-80`}>
            {cmsComponentData?.image?.url && (
              <Image
                priority
                src={cmsComponentData?.image?.url}
                alt={cmsComponentData?.image?.description}
                fill
                style={{ objectFit: 'cover' }}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                width={500}
                height={500}
              />
            )}
          </div>
          <div className="flex-1 flex-grow px-24 pb-24 md:px-28 lg:px-48 xl:px-60 2xl:pl-61 2xl:pr-47 3xl:pl-83 3xl:pr-72">
            {cmsComponentData?.title && (
              <Typography
                as="h1"
                className={`${
                  path.includes('bim-library') ? '' : ''
                } pt-37 text-center text-32 font-medium leading-10 text-primary-black md:text-40 lg:p-16 lg:leading-[3.5rem] xl:p-16  2xl:p-16 2xl:text-48`}
              >
                {cmsComponentData?.title}
              </Typography>
            )}
            {cmsComponentData?.description && (
              <div
                className={`${
                  path.includes('brands')
                    ? 'image-container px-24 text-center text-16 font-normal leading-6 text-[#333] md:text-18  lg:leading-8 xl:text-16 2xl:text-20 [&>div>img]:mb-10'
                    : 'list-container pt-24 text-left text-16 font-normal leading-6 text-[#333] md:text-18 lg:p-16 lg:!text-left lg:leading-8 xl:p-16 xl:!text-left  2xl:p-16 2xl:!text-left 2xl:text-20 [&>p]:mb-16 '
                }`}
                dangerouslySetInnerHTML={{ __html: cmsComponentData?.description }}
              ></div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default PLPCMSComponent;
